import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import LanguageIcon from '@material-ui/icons/Language';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  languageButton: {
    marginLeft: theme.spacing(1),
  },
  menuItem: {
    minWidth: 120,
  },
  activeLanguage: {
    fontWeight: 'bold',
    backgroundColor: theme.palette.action.selected,
  },
}));

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    handleClose();
  };

  const getCurrentLanguage = () => {
    return i18n.language || 'es';
  };

  const isActive = (lng) => {
    const currentLng = getCurrentLanguage();
    return currentLng.startsWith(lng);
  };

  return (
    <>
      <IconButton
        onClick={handleClick}
        color="inherit"
        className={classes.languageButton}
        aria-label="cambiar idioma"
      >
        <LanguageIcon />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        keepMounted
      >
        <MenuItem
          onClick={() => changeLanguage('es')}
          className={`${classes.menuItem} ${isActive('es') ? classes.activeLanguage : ''}`}
        >
          Español
        </MenuItem>
        <MenuItem
          onClick={() => changeLanguage('de')}
          className={`${classes.menuItem} ${isActive('de') ? classes.activeLanguage : ''}`}
        >
          Deutsch
        </MenuItem>
      </Menu>
    </>
  );
}
